import api from "./api";

class CountryServices {
  static getAll() {
    return api.get("/country");
  }
}

export default CountryServices;
